import { render, staticRenderFns } from "./ChooseDividendOption.vue?vue&type=template&id=267b3341"
import script from "./ChooseDividendOption.vue?vue&type=script&lang=js"
export * from "./ChooseDividendOption.vue?vue&type=script&lang=js"
import style0 from "./ChooseDividendOption.vue?vue&type=style&index=0&id=267b3341&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports